/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useStyletron} from 'baseui'
import {Block} from 'baseui/block'
import {Button} from 'baseui/button'
import {
  ALIGN,
  HeaderNavigation,
  StyledNavigationItem as NavigationItem,
  StyledNavigationList as NavigationList,
} from 'baseui/header-navigation'
import {StyledLink} from 'baseui/link'
import React, {useState} from 'react'
import {Link} from 'react-router-dom'

import {assets, routes} from '../../utils/config'
import HeaderAuthMenu from './header-auth-menu'
import HeaderMobileMenu from './header-mobile-menu'

const Header = () => {
  const [useCss, theme] = useStyletron()

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(state => !state)
  }

  return (
    <>
      <HeaderNavigation
        overrides={{
          Root: {
            style: ({$theme}) => ({
              borderBottomWidth: 0,
              justifyContent: 'space-between',
              backgroundColor: $theme.colors.primary50,
              backgroundImage: `url("${assets.navbarBg.location}")`,
              backgroundRepeat: 'repeat-x',
              backgroundSize: 'auto 100%',
              paddingLeft: $theme.sizing.scale800,
              paddingRight: $theme.sizing.scale800,
              paddingTop: $theme.sizing.scale400,
              paddingBottom: $theme.sizing.scale1000,
            }),
          },
        }}
      >
        <Block display="flex" alignItems="center">
          <StyledLink $as={Link} to={routes.home.url} className={useCss({textDecoration: 'none'})}>
            <Block
              as="img"
              src={assets.logoByLRF.location}
              overrides={{
                Block: {
                  style: ({$theme}) => ({
                    cursor: 'pointer',
                    height: '2.5rem',
                    paddingTop: $theme.sizing.scale500,
                    [$theme.media.small]: {
                      height: '4rem',
                      paddingTop: $theme.sizing.scale800,
                    },
                    [$theme.media.medium]: {
                      height: '5rem',
                    },
                  }),
                },
              }}
            />
          </StyledLink>
        </Block>
        <NavigationList $align={ALIGN.right}>
          <NavigationItem
            className={useCss({display: 'none', [theme.media.medium]: {display: 'block'}})}
          >
            <HeaderAuthMenu>
              <FontAwesomeIcon icon="user-circle" size="2x" />
            </HeaderAuthMenu>
          </NavigationItem>
          <NavigationItem
            className={useCss({display: 'block', [theme.media.medium]: {display: 'none'}})}
          >
            <Button type="button" kind="tertiary" onClick={toggleMobileMenu}>
              <FontAwesomeIcon icon={isMobileMenuOpen ? 'times' : 'bars'} />
            </Button>
          </NavigationItem>
        </NavigationList>
      </HeaderNavigation>
      <HeaderMobileMenu isMobileMenuOpen={isMobileMenuOpen} toggleMobileMenu={toggleMobileMenu} />
    </>
  )
}

export default Header
